import { memo } from 'react';
import cn from 'classnames';
import { Box, Element, Image } from 'src/components';
import { IPublisher, ISection } from 'src/interface';
import { TitleWrap } from 'src/modules/shared/components/TitleWrap';
import RouterLink from 'src/components/links';
import useInView from 'src/hooks/useInView';

interface IProps extends ISection<IPublisher> {}

export function PublisherSection({ items = [], title }: IProps) {
    const itemList = [...items, ...items];
    const [inViewRef, inView] = useInView({ rootMargin: '50px' });

    return (
        <Element
            className={cn(
                'publisher-box',
                'p-[8px_20px_16px] mt-[20px] mb-[16px] mx-[-20px]',
                'bg-[#f7f8fa]',
                'bg-[url(https://baomoi-static.bmcdn.me/web/styles/img/pls-bg-1.png)] bg-no-repeat bg-[length:600px_auto] bg-[position:calc(50%-60px)_top]',
            )}
            domRef={inViewRef}
        >
            <TitleWrap
                className="text-[10px] text-[#999] font-[800]"
                title={title}
                renderAs="h2"
            />
            <Box
                className={cn(
                    'relative',
                    'h-[52px]',
                    'pt-[4px]',
                    'overflow-hidden',
                )}
            >
                <Element
                    className={cn(
                        'publisher-wrapper',
                        'absolute flex',
                        'animate-[bannermove_70s_linear_infinite]',
                        {
                            ['[animation-play-state:paused]']: !inView,
                        },
                    )}
                >
                    {itemList?.map((item: IPublisher, index: number) => {
                        return (
                            <RouterLink
                                key={index}
                                to={item.url}
                                className={cn(
                                    'publisher-item',
                                    'flex items-center shrink-0',
                                    'h-[48px] w-[90px]',
                                    'p-[6px] mx-[6px]',
                                    'bg-white',
                                    'border border-solid border-[#E5E5E5]',
                                    'rounded-[4px]',
                                )}
                                newTab={true}
                            >
                                <Image
                                    className="w-full h-full [&_img]:object-contain"
                                    src={item.logo}
                                    alt={item.name}
                                    width={item.width}
                                    height={item.height}
                                />
                            </RouterLink>
                        );
                    })}
                </Element>
            </Box>
        </Element>
    );
}

export default memo(PublisherSection);
